import styled from "styled-components";

const ButtonLayout = styled.div`
  margin-top: 10%;
`;

export default ButtonLayout;
